var creditcards = require('../creditcards/index');

angular.module('component-payments.validate.cvc', [])
	.directive('ctPaymentsValidateCvc', paymentsValidateCvcDirective);

function paymentsValidateCvcDirective() {
	return {
		restrict: 'A',
		require: ['^ctPayments', 'ngModel'],
		link: postLink
	};

	function postLink(scope, element, attrs, ctrls) {
		var CtPaymentsCtrl = ctrls[0],
			NgModelCtrl = ctrls[1];

		NgModelCtrl.$validators.invalidCvc = function (modelValue, viewValue) {
			var value = modelValue || viewValue || '',
				card = CtPaymentsCtrl.getCard();

			return creditcards.cvc.isValid(value, card);
		};
	}
}

module.exports = 'component-payments.validate.cvc';


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/ct-payments/validators/cvc.js
 ** module id = 98
 ** module chunks = 1
 **/